var _path, _path2, _path3, _path4, _g, _ellipse, _path5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpperE(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 102,
    viewBox: "0 0 91 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.2162 5.59059C43.0646 3.36872 47.8059 3.36872 51.6543 5.59059L81.6514 22.9094C85.4998 25.1313 87.8705 29.2374 87.8705 33.6812V68.3188C87.8705 72.7626 85.4998 76.8687 81.6514 79.0906L51.6543 96.4094C47.8059 98.6313 43.0646 98.6313 39.2162 96.4094L9.21908 79.0906C5.3707 76.8687 3 72.7626 3 68.3188V33.6812C3 29.2374 5.3707 25.1313 9.21908 22.9094L39.2162 5.59059Z",
    fill: "#4374A0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.1543 2.99251L83.1514 20.3113C87.928 23.0691 90.8705 28.1657 90.8705 33.6812V68.3188C90.8705 73.8344 87.928 78.9309 83.1514 81.6887L53.1543 99.0075C48.3777 101.765 42.4928 101.765 37.7162 99.0075L7.71908 81.6887C2.9425 78.9309 0 73.8344 0 68.3188V33.6812C0 28.1657 2.9425 23.0691 7.71908 20.3113L37.7162 2.99251C42.4928 0.234748 48.3777 0.234748 53.1543 2.99251ZM51.6543 5.59059C47.806 3.36872 43.0645 3.36872 39.2162 5.59059L9.21908 22.9094C5.3707 25.1313 3 29.2374 3 33.6812V68.3188C3 72.7626 5.3707 76.8687 9.21908 79.0906L39.2162 96.4094C43.0645 98.6313 47.806 98.6313 51.6543 96.4094L81.6514 79.0906C85.4998 76.8687 87.8705 72.7626 87.8705 68.3188V33.6812C87.8705 29.2374 85.4998 25.1313 81.6514 22.9094L51.6543 5.59059Z",
    fill: "#4374A0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2162 5.59059C43.0646 3.36872 47.8059 3.36872 51.6543 5.59059L81.6514 22.9094C85.4998 25.1313 87.8705 29.2374 87.8705 33.6812V68.3188C87.8705 72.7626 85.4998 76.8687 81.6514 79.0906L51.6543 96.4094C47.806 98.6313 43.0645 98.6313 39.2162 96.4094L9.21908 79.0906C5.3707 76.8687 3 72.7626 3 68.3188V33.6812C3 29.2374 5.3707 25.1313 9.21908 22.9094L39.2162 5.59059Z",
    fill: "#87E1FE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.1514 25.5075L50.1543 8.18866C47.2341 6.5027 43.6363 6.5027 40.7162 8.18866L10.7191 25.5075C7.7989 27.1935 6 30.3092 6 33.6812V68.3188C6 71.6908 7.7989 74.8066 10.7191 76.4925L40.7162 93.8113C43.6363 95.4973 47.2342 95.4973 50.1543 93.8113L80.1514 76.4925C83.0716 74.8066 84.8705 71.6908 84.8705 68.3188V33.6812C84.8705 30.3092 83.0716 27.1935 80.1514 25.5075ZM51.6543 5.59059C47.806 3.36872 43.0645 3.36872 39.2162 5.59059L9.21908 22.9094C5.3707 25.1313 3 29.2375 3 33.6812V68.3188C3 72.7626 5.3707 76.8687 9.21908 79.0906L39.2162 96.4094C43.0646 98.6313 47.806 98.6313 51.6543 96.4094L81.6514 79.0906C85.4998 76.8687 87.8705 72.7626 87.8705 68.3188V33.6812C87.8705 29.2374 85.4998 25.1313 81.6514 22.9094L51.6543 5.59059Z",
    fill: "#FFFBF0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1152_17015)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.3052 50.4359H53.6072V51.4359H33.3052V50.4359Z",
    fill: "#4374A0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.8052 31.8174H57.0001V32.8174H33.8052V69.1948H57.0001V70.1948H32.8052V31.8174Z",
    fill: "#4374A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33 32.9157H57",
    stroke: "#D8367D",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 55.4852,
    cy: 32.5978,
    rx: 4.45776,
    ry: 4.48527,
    transform: "rotate(90 55.4852 32.5978)",
    fill: "#4374A0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0429 32.5439L57.9326 29.761L56.0588 32.5269L58.0159 35.152L52.0429 32.5439Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1152_17015"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 38,
    fill: "white",
    transform: "translate(33 32)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpperE);
export default __webpack_public_path__ + "static/media/UPPER_E.33a85c9082a367db46ced699dd27279c.svg";
export { ForwardRef as ReactComponent };